import { NFTTYPE } from '../constants/bakery/nft'

export function userNFTType(nftType: string) {
    let type = NFTTYPE.DOGGIES_V3
    switch (nftType) {
      case '104':
        type = NFTTYPE.DOGGIES_V3
      break
      case '108':
        type = NFTTYPE.BARKING_V3
      break
      case '114':
        type = NFTTYPE.EQUIPMENT_V3
      break
    }
    return type
  }
